import { endpoint, appId, token } from 'core-request';

export const handleLogout = async (client?: string) => {
  const currentUrl = window.location.href;
  let url = `${(await endpoint.getDomain('auth')).auth}/logout?app=${appId}&redirect_uri=${currentUrl}`;
  if (client) {
    url += `&client=${client}`;
  }

  window.location.href = url;
};

export const getRedirect = (oldUrl: string) => {
  const parseUrl = new URL(oldUrl);

  const queryUrl = parseUrl.searchParams;
  const urlRedirect = queryUrl.get('redirect_uri') as string;
  const app = queryUrl.get('app') as string;
  const client = queryUrl.get('client') as string

  const parseUrlRedirect = urlRedirect ? new URL(urlRedirect).origin : '';

  return {
    urlRedirect: urlRedirect || '',
    app: app || '',
    hostName: parseUrlRedirect || '',
    client: client || ''
  };
};

export const getRefreshTokenByApp = (value: string) => {
  if (value === 'fullloop:composer-app') {
    return token.getComposerRefresh();
  } else if (value === 'fullloop:survey-app') {
    return token.getSurveyRefresh();
  } else if (value === 'fullloop:callcenter-app') {
    return token.getCallCenterRefresh();
  } else if (value === 'fullloop:report-app') {
    return token.getReportRefresh();
  }

  return '';
};
